import * as React from 'react';
import 'isomorphic-fetch';
import { Sentence } from "../Sentence";
import { Content } from "../Content";
export class BlogDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = { loading: true, blog: null };
        fetch('Data/GetBlogDetails/' + this.props.blogId, { credentials: 'same-origin' })
            .then(response => response.json())
            .then(data => {
            this.setState({ loading: false, blog: data });
        });
    }
    render() {
        let result = React.createElement("div", null);
        if (this.state.loading) {
            result = React.createElement("div", null, "Fetching blog info...");
        }
        else {
            let blog = this.state.blog;
            let imagesSection = React.createElement("table", { className: 'table' },
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null, "Id"),
                        React.createElement("th", null, "Title"),
                        React.createElement("th", null, "Date"),
                        React.createElement("th", null, "Posted By"))),
                React.createElement("tbody", null,
                    React.createElement("tr", { key: blog.id },
                        React.createElement("td", null, blog.id),
                        React.createElement("td", null, blog.title.data),
                        React.createElement("td", null, blog.date),
                        React.createElement("td", null, blog.postedBy))));
            result = React.createElement("div", null,
                imagesSection,
                React.createElement("br", null),
                React.createElement("b", null, "Summary:"),
                React.createElement("br", null),
                React.createElement(Sentence, { sentenceId: this.state.blog.summary.id, initialText: this.state.blog.summary.data, languageId: 1 }),
                React.createElement("br", null),
                React.createElement("br", null),
                React.createElement("b", null, "Full Article:"),
                React.createElement("br", null),
                React.createElement(Content, { contentId: this.state.blog.fullArticle.id, initialText: this.state.blog.fullArticle.data, languageId: 1 }),
                React.createElement("br", null),
                React.createElement("br", null));
        }
        return result;
    }
}
//# sourceMappingURL=BlogDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./ClientApp/Blog/BlogDetails.js
// module id = 93
// module chunks = 0